import styled from "styled-components";

export const SvgIconBase = styled.svg<{ scale?: number; }>`
	scale: ${({ scale }) => scale ? scale : 1};
`;

